import React, { useMemo } from "react";
import SingleSelectDropdown from "./base/SingleSelectDropdown";
import { HierarchyViewTypeEnum } from "../../../util";

const HierarchySelect = ({ value, onChange, defaultSelected = HierarchyViewTypeEnum.ALL, directlyLabel = "app.hierarchy.directly", allLabel = "app.hierarchy.all" }) => {
  const hierarchyOptions = useMemo(
    () => [
      { value: HierarchyViewTypeEnum.ALL, label: allLabel },
      { value: HierarchyViewTypeEnum.DIRECTLY, label: directlyLabel },
    ],
    [directlyLabel, allLabel],
  );

  return (
    <SingleSelectDropdown
      canClear={false}
      defaultSelected={defaultSelected}
      onChange={onChange}
      value={value}
      values={hierarchyOptions}
      title="app.hierarchy"
    />
  );
};

export default HierarchySelect;
